import React, { useState } from "react";
import { View, StyleSheet, FlatList, Image, Dimensions, Modal, Linking } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";

import config from "../config/config";
import AppButton from "./AppButton";
import AppButtonGoBack from "./buttons/AppButtonGoBack";
import IconTouchable from "./IconTouchable";
import { Video, AVPlaybackStatus } from "expo-av";

function ImageViewer({ imageData, vehicle, imageViewer, setImageViewer, deleteApi }) {
    const { width, height } = Dimensions.get("screen");
    const IMAGE_SIZE = 100;
    const video = React.useRef(null);

    const deleteImage = async () => {
        const response = await deleteApi.request(vehicle, imageData[activeIndex]);
        if (response.ok) {
            console.log("image deleted : " + imageData[activeIndex]);
        } else {
            console.log("failed to delete");
        }
    };

    const closeModal = async () => {
        setImageViewer(false);
    };

    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <Modal animationType="slide" transparent={true} visible={imageViewer ? true : false}>
            <View style={styles.goBackButton}>
                <AppButtonGoBack
                    size={50}
                    onPress={() => {
                        closeModal();
                    }}
                />
            </View>
            <View style={styles.imageContainer}>
                <View style={styles.deleteImage}>
                    <IconTouchable name="delete" backgroundColor={config.colors.danger} iconColor={config.colors.white} size={50} onPress={() => deleteImage()} />
                </View>
                <FlatList
                    data={imageData}
                    keyExtractor={(item) => item}
                    horizontal={true}
                    pagingEnabled={true}
                    showsHorizontalScrollIndicator={false}
                    renderItem={({ item }) => {
                        return (
                            <View style={{ width, height }}>
                                {item.slice(-4) == ".mov" ? (
                                    <Video
                                        ref={video}
                                        style={styles.video}
                                        source={{
                                            uri: item,
                                        }}
                                        useNativeControls
                                        resizeMode="contain"
                                        isLooping
                                        onPlaybackStatusUpdate={(status) => setStatus(() => status)}
                                    />
                                ) : (
                                    <Image source={{ uri: imageData[activeIndex] }} resizeMode="contain" style={{ width, height }} />
                                )}
                            </View>
                        );
                    }}
                />
                <FlatList
                    style={styles.miniImages}
                    data={imageData}
                    keyExtractor={(item) => item}
                    horizontal={true}
                    contentContainerStyle={{ paddingHorizontal: 10 }}
                    showsHorizontalScrollIndicator={false}
                    renderItem={({ item, index }) => {
                        return (
                            <TouchableOpacity onPress={() => setActiveIndex(index)}>
                                {item.slice(-4) == ".mov" ? (
                                    <Video
                                        ref={video}
                                        style={{
                                            width: IMAGE_SIZE,
                                            height: IMAGE_SIZE,
                                            borderRadius: 12,
                                            marginRight: 10,
                                            borderWidth: 2,
                                            borderColor: activeIndex == index ? "#fff" : "transparent",
                                        }}
                                        source={{
                                            uri: item,
                                        }}
                                        resizeMode="cover"
                                        poster={true}
                                        onPlaybackStatusUpdate={(status) => setStatus(() => status)}
                                    />
                                ) : (
                                    <Image
                                        source={{ uri: item }}
                                        style={{
                                            width: IMAGE_SIZE,
                                            height: IMAGE_SIZE,
                                            borderRadius: 12,
                                            marginRight: 10,
                                            borderWidth: 2,
                                            borderColor: activeIndex == index ? "#fff" : "transparent",
                                        }}
                                    />
                                )}
                            </TouchableOpacity>
                        );
                    }}
                ></FlatList>
            </View>
        </Modal>
    );
}
const styles = StyleSheet.create({
    video: {
        marginTop: 150,
        width: "100%",
        height: "60%",
    },
    backgroundVideo: {
        flex: 1,
    },
    downloadButton: {
        position: "absolute",
        top: 400,
    },
    goBackButton: {
        position: "absolute",
        zIndex: 20,
        top: 50,
        left: 20,
    },
    deleteText: {
        fontSize: 60,
        color: config.colors.white,
    },
    deleteImage: {
        position: "absolute",
        right: 20,
        top: 50,
        zIndex: 20,
        fontWeight: "100",
    },
    miniImages: {
        position: "absolute",
        bottom: 80,
        borderRadius: 12,
        marginRight: 10,
    },
    imageContainer: {
        backgroundColor: "#000",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
    },
    text: {
        alignSelf: "center",
        fontSize: 16,
        fontWeight: "900",
        color: config.colors.white,
    },
    image: { flex: 1 },
});

export default ImageViewer;
